#import "../ApprovalsListFields.graphql"

mutation ApprovalRevision($input: ApprovalRevisionInput!) {
  approvalRevision(input: $input) {
    clientMutationId
    approval {
      ...ApprovalsListFields
    }
  }
}
